import { Link } from "react-router-dom";

export default function BillingCancel() {
  return (
    <div
      data-testid="billing-cancel-page"
      className="min-h-screen flex items-center justify-center bg-app"
    >
      <div className="bg-surface border border-app rounded-2xl p-10 max-w-md w-full mx-4 text-center">
        <h1 className="font-heading text-3xl text-text-primary">
          Betalning avbruten.
        </h1>
        <p className="mt-4 text-text-muted text-sm">
          Ingen debitering skedde. Du kan starta om betalningen när du vill.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Link
            to="/billing"
            className="tk-btn-primary"
            data-testid="billing-cancel-retry-link"
          >
            Tillbaka till fakturasidan
          </Link>
        </div>
      </div>
    </div>
  );
}
